import { number } from 'core-ui/plugins/CoreUiFilters.js'

const emailFormatter = (value, key, item) => item?.metricsDTO?.additionalMetrics?.[key]

const emailMetricColumnDefaults = {
  validChannels: [34],
  formatter: (value, key, item) => number(item?.metricsDTO?.additionalMetrics?.[key], 1, true),
  filterByFormatted: emailFormatter,
  sortByFormatted: emailFormatter,
  tdClass: 'font-numeric',
  thClass: 'text-right',
  sortable: true,
  filter: true,
  filterOptions: ['numeric']
}

const emailMetricDefinitions = {
  emailClicks: {
    ...emailMetricColumnDefaults,
    key: 'emailClicks'
  },
  emailUniqueClicks: {
    ...emailMetricColumnDefaults,
    key: 'emailUniqueClicks'
  },
  emailOpens: {
    ...emailMetricColumnDefaults,
    key: 'opens'
  },
  uniqueEmailOpens: {
    ...emailMetricColumnDefaults,
    key: 'uniqueOpens'
  },
  emailsScheduled: {
    ...emailMetricColumnDefaults,
    key: 'scheduled'
  },
  emailsDelivered: {
    ...emailMetricColumnDefaults,
    key: 'delivered'
  },
  softBounceCount: {
    ...emailMetricColumnDefaults,
    key: 'softBounceCount'
  },
  hardBounceCount: {
    ...emailMetricColumnDefaults,
    key: 'hardBounceCount'
  },
  blockBounceCount: {
    ...emailMetricColumnDefaults,
    key: 'blockBounceCount'
  },
  unsubscribes: {
    ...emailMetricColumnDefaults,
    key: 'unsubscribes',
    defaultWidth: 110
  },
  trackedUnsubscribes: {
    ...emailMetricColumnDefaults,
    key: 'trackedUnsubscribes',
    defaultWidth: 110
  },
  uniqueEmailUsers: {
    ...emailMetricColumnDefaults,
    key: 'uniqueUsers'
  }
}

export const emailMetricColumns = Object.keys(emailMetricDefinitions)
export default emailMetricDefinitions
